import { EmployeeDataFieldState, FieldType } from '../../__generated__/graphql';

export type EmployeeSection = {
  label: string;
  fields: EmployeeFieldFull[];
};

export type EmployeeFieldFull = EmployeeFieldWithState & {
  oldValue: string | null;
  pendingApproval: boolean;
};

export type EmployeeFieldWithState = EmployeeField & {
  state: EmployeeDataFieldState;
};

export type EmployeeField = {
  fieldInfo: FieldInfo;
  value: string | null;
};

export type FieldInfo = {
  name: string;
  label: string;
  disabled: boolean;
  required: boolean;
  type: FieldType;
  hint?: string;
  minRows?: number;
  step?: string;
  options: FieldOption[];
  doNotInsertDefaultOptions?: boolean;
  defaultValue?: string;
  onChange?: (value: any, fieldInfo: FieldInfo) => void;
};

export type FieldOption = {
  label: string;
  value: string;
};

// stable identity so components that take no options don't get a fresh array per render
export const NO_OPTIONS: readonly FieldOption[] = [];

export type EmployeeRelatedList = {
  label: string;
  objectType: string;
  records: EmployeeRelatedListRecord[];
};

export type EmployeeRelatedListRecord = {
  id: string;
  fields: EmployeeFieldFull[];
};
